import LoadingStatus from '@libs/loading-status';

import { RootState } from '@app/store/types';
import { getUser } from '@app/store/user/selectors';

/**
 * user 데이터 전체를 가져온다.
 */
export const getUserData = (state: RootState) => getUser(state).user;
export const getUserAuthority = (state: RootState) => getUser(state).authority;
const getUserSurveyData = (state: RootState) => getUserData(state).survey;

export const getActivatedAt = (state: RootState) => getUserData(state).activatedAt;

export const getEmail = (state: RootState) => getUserData(state).email;
export const getName = (state: RootState) => getUserData(state).name;

export const getPhoneNumber = (state: RootState) => getUserSurveyData(state)?.phoneNumber;
export const getProviders = (state: RootState) => getUserData(state).providers;
export const getUserID = (state: RootState) => getUserData(state).id;
export const getType = (state: RootState) => getUserSurveyData(state)?.userType;

/**
 * 유저 정보의 로딩 상태를 반환한다.
 */
export const getUserLoadingStatus = (state: RootState): LoadingStatus => getUserData(state).status;

/**
 * 설문조사 여부를 반환한다.
 */
export const getExistUserSurvey = (state: RootState) => !!getUserSurveyData(state)?.userType;
